'use strict';

module.exports = '2.9.0';



/*****************
 ** WEBPACK FOOTER
 ** ./~/algoliasearch-helper/src/version.js
 ** module id = 213
 ** module chunks = 0
 **/